import { reduce } from "et3-type-guards";

import configuration from "../../configuration/keys";
import { EEnvironment } from "../../constants/enum/environment";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import {
  HEADER_CHIP_GAP,
  HEADER_CHIP_RADIUS,
  HEADER_COMPACT_CHIP_FONT_SIZE,
  HEADER_COMPACT_CHIP_HEIGHT,
  HEADER_COMPACT_CHIP_PADDING_X,
  HEADER_CHIP_FONT_SIZE,
  HEADER_CHIP_HEIGHT,
  HEADER_CHIP_PADDING_X,
  HEADER_DOT_SIZE
} from "./header-constants";
import { getHeaderIsCompactFromStore } from "./header-layout";

const ENVIRONMENT_LABEL_PRODUCTION = "PROD";
const ENVIRONMENT_LABEL_PRE_PROD = "PRE-PROD";
const ENVIRONMENT_LABEL_STAGING = "STAGING";
const ENVIRONMENT_LABEL_DEVELOPMENT = "DEV";
const ENVIRONMENT_LABEL_LOCAL = "LOCAL";
const ENVIRONMENT_LETTER_SPACING = 0.6;

const HeaderEnvironmentChip = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const isCompact = getHeaderIsCompactFromStore();
  const environment = reduce(() => configuration.environment, "");
  const chipHeight = isCompact
    ? HEADER_COMPACT_CHIP_HEIGHT
    : HEADER_CHIP_HEIGHT;
  const chipPaddingX = isCompact
    ? HEADER_COMPACT_CHIP_PADDING_X
    : HEADER_CHIP_PADDING_X;
  const fontSize = isCompact
    ? HEADER_COMPACT_CHIP_FONT_SIZE
    : HEADER_CHIP_FONT_SIZE;

  const accent = (() => {
    switch (environment) {
      case EEnvironment.PRODUCTION:
        return colors.all.red;
      case EEnvironment.PRE_PROD:
        return colors.all.darkOrange;
      case EEnvironment.STAGING:
        return colors.all.purple;
      case EEnvironment.DEVELOPMENT:
        return colors.all.bondiBlue;
      default:
        return colors.all.limeGreen;
    }
  })();

  const label = (() => {
    switch (environment) {
      case EEnvironment.PRODUCTION:
        return ENVIRONMENT_LABEL_PRODUCTION;
      case EEnvironment.PRE_PROD:
        return ENVIRONMENT_LABEL_PRE_PROD;
      case EEnvironment.STAGING:
        return ENVIRONMENT_LABEL_STAGING;
      case EEnvironment.DEVELOPMENT:
        return ENVIRONMENT_LABEL_DEVELOPMENT;
      default:
        return ENVIRONMENT_LABEL_LOCAL;
    }
  })();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={chipHeight}
      height={chipHeight}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={`${accent}1F`}
      style={{
        boxSizing: "border-box",
        width: "auto",
        minWidth: 0,
        flexShrink: 0,
        height: chipHeight * unitY,
        borderRadius: HEADER_CHIP_RADIUS * unitX,
        paddingLeft: chipPaddingX * unitX,
        paddingRight: chipPaddingX * unitX,
        gap: HEADER_CHIP_GAP * unitX,
        whiteSpace: "nowrap"
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={HEADER_DOT_SIZE}
        height={HEADER_DOT_SIZE}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={accent}
        style={{
          flexShrink: 0,
          borderRadius: HEADER_DOT_SIZE * unitX,
          boxShadow: `0 0 ${HEADER_DOT_SIZE * unitX}px ${accent}`
        }}
        onClick={() => {}}
      />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={fontSize}
        text={label}
        isSpan={false}
        color={accent}
        style={{
          margin: 0,
          whiteSpace: "nowrap",
          letterSpacing: ENVIRONMENT_LETTER_SPACING * unitX
        }}
      />
    </ET3Div>
  );
});
export default HeaderEnvironmentChip;
